var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 47.97" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-tags"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M46.68 22.35L23 1a4 4 0 0 0-2.68-1H4a4 4 0 0 0-4 4v17.68a4 4 0 0 0 1.27 2.92l23.82 22.29a4 4 0 0 0 5.71-.24L47 28a4 4 0 0 0-.32-5.65zM12 16.5a4.5 4.5 0 1 1 4.5-4.5 4.5 4.5 0 0 1-4.5 4.5z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});